import { createSelector } from 'reselect';
import { initVisitor } from '@laigu/utils';

type VisitinfoExtra = {
  sourceInfo: SourceInfo;
  utm: VisitUtm;
  avatar: {
    type: string;
    src: string;
  };
};

export const getInitVisitor = createSelector([(visitInfo: VisitInfo) => visitInfo], (visitInfo): VisitInfo &
  VisitinfoExtra => initVisitor(visitInfo));
